import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable, of, throwError } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse,HttpParams } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class GlobalsService {

	key = 'UET6DFMPAXW7BKCB';
	config: any;
	color = 'blue';
	user: any = [];
	public localStorageKey = 'v8ConfigOverride';
	private defaultConfig = `assets/config/config.${environment.name}.json`;

	constructor(private http: HttpClient, private httpClient: HttpClient, private _configSvc: RuntimeConfigLoaderService) {
		this.loadConfig();
		//this._configSvc.getConfig()
		const user = JSON.parse(localStorage.getItem('user'));
		if (user !== null && user) {
			this.user = user;
		}
	}

	loadConfig() {
		const localConfig = localStorage.getItem(this.localStorageKey);

		if (localConfig) {
			try {
				const config = JSON.parse(localConfig);
				if (this.isValidConfig(config)) {
					this.config = config;
					this.mergeArConfigIntoConfig();
				} else {
					this.loadConfigFromServer();
				}
			} catch (error) {
				this.loadConfigFromServer();
			}
		} else {
			this.loadConfigFromServer();
			if (!this.config) {
				this.config = this._configSvc.getConfig();
			}
		}
	}

	private loadConfigFromServer() {
		const jsonFile = `assets/config/config.${environment.name}.json`;
		this.http.get(jsonFile).toPromise().then(config => {
			if (this.isValidConfig(config)) {
				this.config = config;
				this.mergeArConfigIntoConfig();
			}
		}).catch(() => {});
	}

	private isValidConfig(config: any): boolean {
		//console.log('Validating configuration:', config);

		if (!config) {
			//console.error('Configuration is null or undefined.');
			return false;
		}
		if (typeof config.apiCredentials.clientId !== 'string') {
			//console.error('Invalid or missing "clientId":', config.clientId);
			return false;
		}
		if (!config.env || typeof config.env.package !== 'string') {
			//console.error('Invalid or missing "env.package":', config.env);
			return false;
		}
		return true;
	}

	public updateConfigFile(newConfig: any) {
		this.config = newConfig;
		try {
			localStorage.setItem(this.localStorageKey, JSON.stringify(newConfig));
		} catch (e) {}
		this.mergeArConfigIntoConfig();
	}
	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	public setColor(value: any): string {
		localStorage.setItem('color', JSON.stringify(value))
		this.color = value;
		return value;
	}

	public getColor(): string {
		let color = JSON.parse(localStorage.getItem('color'));
		if (color === null) {
			color = 'blue';
			localStorage.setItem('color', JSON.stringify('blue'))
		}
		this.color = color;
		return color;
	}

	public saveContactType(data: any) {
		const method = 'globals/types/contacttypeupdate';
		return this.http.post(this.setEndPoint(method), data);
	}

	public removeContactType(data: any) {
		const method = 'globals/types/contacttyperemove';
		return this.http.post(this.setEndPoint(method), data);
	}

	public getApiConfig() {
		this.config.color = this.getColor();
		return this.config;
	}
	public getItemBarcodes(stockid: any) {
		const method = 'inventory/barcodes&stockid=' + stockid;
		return this.http.get(this.setEndPoint(method));
	}

	public getItemSetup() {
		const method = 'inventory/properties';
		return this.http.get(this.setEndPoint(method));
	}
	public getInvoice(id: any, display: any) {
		const method = 'documents/invoice&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}
	public getTransfer(id: any, display: any) {
		const method = 'documents/transfer&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}
	public getVendorInvoice(id: any, display: any) {
		const method = 'documents/vendorinvoice&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}
	public getVendorCreditNote(id: any, display: any) {
		const method = 'documents/vendorcredit&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}

	public getPOSReceipt(id: any, display: any) {
		const method = 'documents/receipt/posreceiptorder&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}

	public emailPOSReceipt(id: any, display: any, email: any) {
		const method = 'documents/receipt/posreceiptorder&id=' + id + '&display=' + display + '&email=' + email;
		return this.http.get(this.setEndPoint(method));
	}

	public emailInvoice(id: any, display: any, email: any) {
		const method = 'documents/invoice&id=' + id + '&display=' + display + '&email=' + email;
		return this.http.get(this.setEndPoint(method));
	}

	public emailInvoiceCustomerTrans(data: any) {
	  const method = 'documents/invoice';

	  // Construct query parameters from the payload
	  const params = new HttpParams()
			.set('id', data.id)
			.set('display', data.display)
			.set('email', data.email)
			.set('savecontact', data.savecontact);

	  return this.http.get(this.setEndPoint(method), { params, ...this.httpOptions }).pipe(
			catchError(this.handleError('company', data))
	  );
	}



	public emailQuoteInvoice(id: any, email: any, display: any) {
		const method = `documents/quote&id=${id}&email=${email}&display=${display}`;
		return this.http.get(this.setEndPoint(method));
	}

	public getQuoteInvoice(id: any, display: any) {
		const method = `documents/quote&id=${id}&display=${display}`;
		return this.http.get(this.setEndPoint(method));
	}

	public removeSalesType(data: any) {
		const method = 'globals/types/salestyperemove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public removeCustomerType(data: any) {
		const method = 'globals/types/customertyperemove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}


	public saveShipVia(data: any) {
		const method = 'globals/shipvia/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public removeShiper(data: any) {
		const method = 'globals/shipvia/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public removePaymentTerm(data: any) {
		const method = 'globals/terms/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public savePaymentTerm(data: any) {
		const method = 'globals/terms/add';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public savePaymentType(data: any) {
		const method = 'globals/types/paymentmethodupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public removePaymentType(data: any) {
		const method = 'globals/types/paymentmethodremove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public saveCustomerType(data: any) {
		const method = 'globals/types/customertypeupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public saveVendorType(data: any) {
		const method = 'globals/types/vendortypeupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public removeVendorType(data: any) {
		const method = 'globals/types/vendortyperemove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public saveSalesType(data: any) {
		const method = 'globals/types/salestypeupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getCreditNote(id: any, display: any) {
		const method = 'documents/credits&id=' + id + '&display=' + display;
		return this.http.get(this.setEndPoint(method));
	}

	public emailReceiptCustomerTrans(data: any) {
		const method = 'documents/receipt';

		const payload = {
			id: data.id,
			display: data.display,
			email: data.email,
			savecontact: data.savecontact,
		}

		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public emailReceipt(id: any, display: any, email: any) {
		const method = 'documents/receipt&id=' + id + '&display=' + display + '&email=' + email;
		return this.http.get(this.setEndPoint(method));
	}

	public emailCreditNote(id: any, display: any, email: any) {
		const method = 'documents/credits&id=' + id + '&display=' + display + '&email=' + email;
		return this.http.get(this.setEndPoint(method));
	}

	public getHowPaid(transno: any, type: any) {
		const method = 'payments/allocations/view&id=' + transno + '&type=' + type;
		return this.http.get(this.setEndPoint(method));
	}

	public getSupplierHowPaid(transno: any, type: any) {
		const method = 'payments/allocations/purchaseview&id=' + transno + '&type=' + type;
		return this.http.get(this.setEndPoint(method));
	}

	public getTransactionGl(transno: any, type: any) {
		const method = 'globals/glaccounts/transaction&transno=' + transno + '&type=' + type;
		return this.http.get(this.setEndPoint(method));
	}

	public getAllocations(id: any) {
		const method = 'payments/allocations/view&id=' + id;
		return this.http.get(this.setEndPoint(method));
	}

	public getVendoorAllocations(id: any) {
		const method = 'vendor/allocations/view&id=' + id;
		return this.http.get(this.setEndPoint(method));
	}


	public getVendoorAllocationsWType(id: any, type: any) {
		const method = 'vendor/allocations/view&id=' + id +'&type=' + type;
		return this.http.get(this.setEndPoint(method));
	}

	public dealllocateDocument(data: any) {
		const method = 'globals/allocations/deallocatesupptrans';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('payments', data))
		);
	}

	public getDataSets() {
		const method = 'globals/datasets';
		return this.http.get(this.setEndPoint(method));
	}

	public getPaymentMethods() {
		const method = 'globals/paymentmethods';
		return this.http.get(this.setEndPoint(method));
	}
	public getSettings() {
		const method = 'globals/settings/setting';
		return this.http.get(this.setEndPoint(method));
	}

	public getCompany() {
		const method = 'globals/settings/company';
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError((err) => {
				console.error('Failed to load company:', err);
				return of(null);
			})
		);
	}

	public getArConfig() {
		const method = 'globals/settings/arConfig';
		return this.http.get(this.setEndPoint(method));
	}

	public saveArConfig(data: { overdueOnHold?: any; arInterestRates?: any }) {
		const method = 'globals/settings/arConfigSave';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions);
	}

	public mergeArConfigIntoConfig() {
		if (!this.config) { return; }
		this.getArConfig().subscribe({
			next: (data: any) => {
				if (data && this.config) {
					if (data.overdueOnHold != null) { this.config.overdueOnHold = data.overdueOnHold; }
					if (data.arInterestRates != null) { this.config.arInterestRates = data.arInterestRates; }
				}
			}
		});
	}

	public getConfigKeyPairs() {
		const method = 'globals/settings/configkeypair';
		return this.http.get(this.setEndPoint(method));
	}

	public getConfigKeyPairsWithType() {
		const method = 'globals/settings/configkeypairwithtype';
		return this.http.get(this.setEndPoint(method));
	}

	private checkCreditLimits$: Observable<number> | null = null;

	public getCheckCreditLimits(): Observable<number> {
		if (!this.checkCreditLimits$) {
			this.checkCreditLimits$ = this.getConfigKeyPairs().pipe(
				map((kp: any) => {
					const v = kp && kp['CheckCreditLimits'];
					if (v === undefined || v === null || v === '') { return 0; }
					const n = parseInt(v, 10);
					return isNaN(n) ? 0 : Math.max(0, Math.min(2, n));
				}),
				shareReplay(1)
			);
		}
		return this.checkCreditLimits$;
	}

	public getStores() {
		const method = 'globals/stores';
		return this.http.get(this.setEndPoint(method));
	}
	public saveStore(data: any) {
		const method = 'globals/stores/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public removeStore(data: any) {
		const method = 'globals/stores/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesManagers() {
		const method = 'globals/salesman/getsalesmanmanagers';
		return this.http.get(this.setEndPoint(method));
	}

	public getSalesPerson(data: any) {
		const method = 'globals/salesman/getsalesman';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getSalesPeople() {
		const method = 'globals/salesman/fulldetails';
		return this.http.get(this.setEndPoint(method));
	}

	public getActiveSalesPeople() {
		const method = 'globals/salesman/getactivesalesman';
		return this.http.get(this.setEndPoint(method));
	}


	public removeSalesPerson(data: any) {
		const method = 'globals/salesman/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public saveSalesPerson(data: any) {
		const method = 'globals/salesman/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public getDregPayments(data) {
		const method = 'dreg/payments';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public postDreg(dreg) {
		const method = 'dreg/postdreg';
		return this.http.post(this.setEndPoint(method), { dregdata: dreg }, this.httpOptions).pipe(
			catchError(this.handleError(method, dreg))
		);
	}

	public closeDreg(dreg) {
		const method = 'dreg/closedreg';
		return this.http.post(this.setEndPoint(method), { dregdata: dreg }, this.httpOptions).pipe(
			catchError(this.handleError(method, dreg))
		);
	}

	public getDailyARTotals(data) {
		const method = 'globals/dayend';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public postDailyARTotals(data) {
		const method = 'globals/dayend/submit';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getRSI(data) {
		const method = 'globals/dayend/rsi';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public updateLocation(data) {
		const method = 'globals/locations/update';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public removeLocation(data) {
		const method = 'globals/locations/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('locations', data))
		);
	}

	public getLocationDefaults(data){
		const method = 'globals/locations/defaults';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('locations', data))
		);
	}
	
	public saveLocationDefaults(data){
		const method = 'globals/locations/defaultsave';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('locations', data))
		);
	}
	public getTerritories(){
		const method = 'globals/territories';
		return this.http.get(this.setEndPoint(method));
	}
	
	public updateCompany(data) {
		const method = 'globals/settings/updatecompany'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public updateConfig(data) {
		const method = 'globals/settings/updateconfig'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('config', data))
		);
	}

	public addConfig(data) {
		const method = 'globals/settings/addconfig'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('config', data))
		);
	}

	public getConfig() {
		const method = 'globals/settings/config';
		return this.http.get(this.setEndPoint(method));
	}


	public getTypeExclusionRules(data) {
		const method = 'globals/settings/typerules'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public deleteExclusionRule(data) {
		const method = 'globals/settings/typeruledelete'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public saveExclusionRule(data) {
		const method = 'globals/settings/typerulesave'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getFavorites(){
		const method = 'globals/favorites';
		return this.http.get(this.setEndPoint(method));
	}

	public addFavorite(data: any){
		const method = 'globals/favorites/addfavorite';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public removeFavorite(data: any){
		const method = 'globals/favorites/removefavorite';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public reorderFavorites(data: any){
		const method = 'globals/favorites/resort';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public getSalesTypes(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getSalesTypesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching sales types from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getSalesTypes',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/types/sales';
			return this.http.get(this.setEndPoint(method));
		}
	}

	public getTypes(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getTypesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching types from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getTypes',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/types';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getHoldReasons(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getHoldReasonsResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching hold reasons from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getHoldReasons',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/types/holdreasons';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getCountryZoness(id: any): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getCountryZonessResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching country zones from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getCountryZoness',
					payload: {
						config: this.config,
						user: this.user,
						id: id
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = `globals/zones/country&country_id=${id}`;
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getCountryZones(id: any): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getCountryZonesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching country zones from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getCountryZones',
					payload: {
						config: this.config,
						user: this.user,
						id: id
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = `globals/zones/country&country_id=${id}`;
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getDefaultZones(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getDefaultZonesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching default zones from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getDefaultZones',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/zones/defaultzone';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getCustomerTypes(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getCustomerTypesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching customer types from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getCustomerTypes',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/types/customer';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getShipVia(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getShipViaResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching ship via data from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getShipVia',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/shipvia';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getSalesman(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getSalesmanResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching salesman data from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getSalesman',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/salesman';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getAreas(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getAreasResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching areas from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getAreas',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/areas';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getLocations() {

		const user = JSON.parse(localStorage.getItem('user'));
		if (user === null) {
			///return false;
		} else {
			this.user = user;
		}

		const addon = (this.user.user) ? '&userid=' + this.user.user.userid : '';
		const method = 'globals/locations&userid=' + addon;
		return this.http.get(this.setEndPoint(method));
	}

	public getUserLocations() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (user === null) {
			///return false;
		} else {
			this.user = user;
		}

		const addon = (this.user.user) ? '&userid=' + this.user.user.userid : '';
		const method = 'globals/locations&userid=' + addon;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError((err) => {
				console.error('Failed to load user locations:', err);
				return of([]);
			})
		);
	}


	public getLocation(data) {
		const method = 'globals/locations/get';
		return this.http.post(this.setEndPoint(method), { loccode: data }, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getAllLocations(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getAllLocationsResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching all locations from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getAllLocations',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/locations/all';
			return this.http.get(this.setEndPoint(method));
		}
	}

	public getBankAccounts(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getBankAccountsResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching bank accounts from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getBankAccounts',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/bankaccounts';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public getBankAccount(account: any) {
		const method = 'globals/bankaccounts&account=' + account;
		return this.http.get(this.setEndPoint(method));
	}

	public deleteBankAccount(account: any) {
		const method = 'globals/bankaccounts/remove&account=' + account;
		return this.http.get(this.setEndPoint(method));
	}

	public saveBankAccount(data: any) {
		const method = 'globals/bankaccounts/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getAccountSections() {
		const method = 'globals/glaccounts/sections';
		return this.http.get(this.setEndPoint(method));
	}
	public getAccountSection(data) {
		const method = 'globals/glaccounts/sections';
		return this.http.post(this.setEndPoint(method), { sectionid: data }, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public updateSection(data) {
		const method = 'globals/glaccounts/sectionupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public deleteSection(data) {
		const method = 'globals/glaccounts/sectiondelete';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getAccountGroups() {
		const method = 'globals/glaccounts/groups';
		return this.http.get(this.setEndPoint(method));
	}
	public getAccountGroup(data) {
		const method = 'globals/glaccounts/groups';
		return this.http.post(this.setEndPoint(method), { groupname: data }, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public updateGroup(data) {
		const method = 'globals/glaccounts/groupupdate';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public deleteGroup(data) {
		const method = 'globals/glaccounts/groupdelete';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getGLAccounts() {
		const method = 'globals/glaccounts';
		return this.http.get(this.setEndPoint(method));
	}

	public getGLChartExport() {
		const method = 'globals/glaccounts/export';
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError('getGLChartExport', {}))
		);
	}

	public getGLAccount(data) {
		const method = 'globals/glaccounts';
		return this.http.post(this.setEndPoint(method), { accountcode: data }, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public updateGLAccount(data) {
		const method = 'globals/glaccounts/update';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public addGLAccount(data) {
		const method = 'globals/glaccounts/update';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public deleteGLAccount(data) {
		const method = 'globals/glaccounts/gldelete';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getProdLineMarkups(data) {
		const method = 'globals/inventory/getprodlinemarkup';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public saveProdLineMarkup(data) {
		const method = 'globals/inventory/saveprodlinemarkup';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public deleteProdLineMarkup(data) {
		const method = 'globals/inventory/removeprodlinemarkup';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getTransAllocations(data) {

		const method = 'globals/allocations/transallocations';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getAllocationTrans(data: any) {
		const method = 'globals/allocations';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public getAllocationData(data) {
		const method = 'globals/allocations/transallocations';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public addAllocation(data) {
		const method = 'globals/allocations/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}
	public removeAllocation(data) {
		const method = 'globals/allocations/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getTerms(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getTermsResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching terms from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getTerms',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/terms';
			return this.http.get(this.setEndPoint(method));
		}
	}

	public getTaxes(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getTaxesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching taxes from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getTaxes',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'globals/taxes';
			return this.http.get(this.setEndPoint(method));
		}
	}

	public getRemoteAPISettings() {
		const method = 'globals/rapi';
		return this.http.get(this.setEndPoint(method));
	}
	public getRemoteAPI(data) {
		const method = 'globals/rapi/fetch';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getRemoteMap(data) {
		const method = 'globals/rapi/fetchmap';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public getRemoteEx(data) {
		const method = 'globals/rapi/fetchex';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public saveRemote(data) {
		const method = 'globals/rapi/save';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}
	public delRemote(data) {
		const method = 'globals/rapi/remove';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('company', data))
		);
	}

	public getCurrencies(): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getCurrenciesResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching currencies from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getCurrencies',
					payload: {
						config: this.config,
						user: this.user
					}
				}, [messageChannel.port2]);
			}).pipe(
				catchError((err) => {
					console.error('Failed to load currencies:', err);
					return of([]);
				})
			);
		} else {
			const method = 'globals/currancy';
			return this.http.get(this.setEndPoint(method)).pipe(
				catchError((err) => {
					console.error('Failed to load currencies:', err);
					return of([]);
				})
			);
		}
	}

	addCurrency(payload: { currabrev: string; currency: string; rate?: number; symbol_left?: string; symbol_right?: string; decimalplaces?: number; status?: number }): Observable<any> {
		const method = 'globals/currencies/add';
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions);
	}

	updateCurrency(payload: { currency_id?: number; currabrev?: string; currency?: string; rate?: number; symbol_left?: string; symbol_right?: string; decimalplaces?: number; status?: number }): Observable<any> {
		const method = 'globals/currencies/update';
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions);
	}

	deactivateCurrency(payload: { currency_id?: number; currabrev?: string }): Observable<any> {
		const method = 'globals/currencies/deactivate';
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions);
	}

	activateCurrency(payload: { currency_id?: number; currabrev?: string }): Observable<any> {
		const method = 'globals/currencies/activate';
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions);
	}

	public getTerm(code: any): Observable<any> {
		if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
			return new Observable(observer => {
				const messageChannel = new MessageChannel();

				messageChannel.port1.onmessage = (event) => {
					if (event.data.action === 'getTermResponse') {
						if (event.data.data) {
							observer.next(event.data.data);
							observer.complete();
						} else {
							observer.error('Error fetching term from service worker');
						}
					}
				};

				navigator.serviceWorker.controller.postMessage({
					action: 'getTerm',
					payload: {
						config: this.config,
						user: this.user,
						code: code
					}
				}, [messageChannel.port2]);
			});
		} else {
			// Fallback if service worker is not available
			const method = 'inventory/history';
			return this.http.get(this.setEndPoint(method));
		}
	}


	public lookup(data) {
		const method = 'inventory'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('inventory', data))
		);
	}

	public getFilterGroup(id){
		const method = 'users/getfiltergroup&id=' + id;
		return this.http.get(this.setEndPoint(method));
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey() + this.getPackage();
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getPackage() {
		const p = localStorage.getItem('app')
		if (p) {
			return '&package=' + p;
		} else {
			return '';
		}
	}

	private getApiKey() {
		const addon = (this.user.user) ? '&userid=' + this.user.user.userid : '';
		return '&key=' + this.config.apiCredentials.clientId + addon;
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	isEmail(search: string): boolean {
		let serchfind: boolean;
		const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		serchfind = regexp.test(search);
		return serchfind
	}

	private handleError < T > (operation = 'operation', result ? : T) {

		return (error: any): Observable < T > => {
			if (error instanceof HttpErrorResponse && error.status === 401) {
				window.location.href = '/#/auth/login';
			}

			return throwError(() => error);
		};
	}
}
